<script>
import Endpoints from '../../../../components/common/Endpoints';
import Common from '../../../../components/common/Common';
import Request from '../../../../components/common/Request';
import { mapActions } from 'vuex'

export default {
    init: async(payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');
        payload.company = payload.$session.get('user').companyUser.company._id;

    },
    methods:{
      filter: async function(){
       let responseOrdersCertifieds = (await Request.do(this, 'POST', Request.getDefaultHeader(this), 
       {fileName : "OrdersHolder",collectionName : "orders-holder",filters:{status: "ACTIVE",typeOrder:"CERTIFIEDS",company: this.company}}, `${Endpoints.systemUsers.count}`)).data;
       let responseOrdersServices = (await Request.do(this, 'POST', Request.getDefaultHeader(this), 
       {fileName : "OrdersHolder",collectionName : "orders-holder",filters:{status: "ACTIVE",typeOrder:"SERVICES",company: this.company}}, `${Endpoints.systemUsers.count}`)).data;
       let responseOrdersParts = (await Request.do(this, 'POST', Request.getDefaultHeader(this), 
       {fileName : "OrdersHolder",collectionName : "orders-holder",filters:{status: "ACTIVE",typeOrder:"PARTS",company: this.company}}, `${Endpoints.systemUsers.count}`)).data;

        this.total = responseOrdersCertifieds.count+responseOrdersServices.count+responseOrdersParts.count;

        if (responseOrdersCertifieds.status==200 && responseOrdersServices.status==200 && responseOrdersParts.status==200){
            this.chart.data.datasets[0].data = [responseOrdersCertifieds.count,responseOrdersServices.count,responseOrdersParts.count];
            this.chart.update();
        }
      }
    }
}
</script>

          